import React, { FC } from 'react';
import { TagLabel, TagVariant } from '../TagLabel/TagLabel';

export enum InsightType {
  NEW = 'new',
  DELETED = 'deleted',
  CHANGED = 'changed',
  LOSS = 'loss',
  RECOVERED = 'recovered',
  UPDATED = 'updated',
  UNASSOCIATED = 'unassociated'
}

const colors: Record<InsightType, TagVariant> = {
  [InsightType.NEW]: 'infoPrimaryRounded',
  [InsightType.DELETED]: 'warningPrimaryRounded',
  [InsightType.CHANGED]: 'warningPrimaryRounded',
  [InsightType.LOSS]: 'criticalPrimaryRounded',
  [InsightType.RECOVERED]: 'positivePrimaryRounded',
  [InsightType.UPDATED]: 'neutralPrimaryRounded',
  [InsightType.UNASSOCIATED]: 'neutralPrimaryRounded'
};

export type InsightLabelProps = { type: InsightType; tooltipText?: string };

export const InsightLabel: FC<InsightLabelProps> = ({ type, tooltipText }) => {
  return (
    <TagLabel
      variant={colors[type]}
      text={type}
      tooltipText={tooltipText}
      textTransform="uppercase"
    />
  );
};
